import ChatInputMessage from './ChatInputMessage'

export default  ChatInputMessage